var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdPlanPerkBadgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#01c0fa",
    d: "M512 256c0 141.387-114.613 256-256 256S0 397.387 0 256 114.613 0 256 0s256 114.613 256 256zm0 0",
    opacity: 1,
    "data-original": "#4a7aff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26a6fe",
    d: "M512 256c0-1.39-.031-2.777-.055-4.164l-77.925-77.93-55.68 53.32L271.613 120.5 160.391 243.727l70.511 70.515-158.43 71.668L189.939 503.38C211.016 508.992 233.156 512 256 512c141.387 0 256-114.613 256-256zm0 0",
    opacity: 1,
    "data-original": "#0053bf",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe70d",
    d: "M298.016 181.207c0 45.848-37.168 83.016-83.016 83.016s-83.016-37.168-83.016-83.016c0-45.848 37.168-83.016 83.016-83.016s83.016 37.168 83.016 83.016zm0 0",
    opacity: 1,
    "data-original": "#ffd400",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed402",
    d: "M215 98.191c-.441 0-.875.028-1.316.036v165.96c.441.008.875.036 1.316.036 45.848 0 83.016-37.168 83.016-83.016 0-45.848-37.168-83.016-83.016-83.016zm0 0",
    opacity: 1,
    "data-original": "#fdba12",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe70d",
    d: "M72.473 385.91h285.054C346.672 316.96 287.004 264.223 215 264.223S83.328 316.96 72.473 385.91zm0 0",
    opacity: 1,
    "data-original": "#ffd400",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed402",
    d: "M215 264.223c-.438 0-.875.007-1.316.011V385.91h143.843C346.672 316.96 287.004 264.223 215 264.223zm0 0",
    opacity: 1,
    "data-original": "#fdba12",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M464.23 247.238c0 57.504-46.613 104.117-104.117 104.117-57.5 0-104.113-46.613-104.113-104.117 0-57.5 46.613-104.113 104.113-104.113 57.504 0 104.117 46.613 104.117 104.113zm0 0",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dce1eb",
    d: "M360.113 143.125c-.09 0-.183.004-.273.004v208.223l.273.003c57.504 0 104.117-46.613 104.117-104.117 0-57.5-46.613-104.113-104.117-104.113zm0 0",
    opacity: 1,
    "data-original": "#dce1eb"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414952",
    d: "m337.648 317.973-53.043-53.043 28.989-28.993 24.054 24.055 68.989-68.988 28.992 28.988zm0 0",
    opacity: 1,
    "data-original": "#414952",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333940",
    d: "M406.637 191.004 359.84 237.8v57.98l75.789-75.789zm0 0",
    opacity: 1,
    "data-original": "#333940",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdPlanPerkBadgeIcon);
export default __webpack_public_path__ + "static/media/ad-plan-perk-badge-icon.e2a1fbc0c3f73382f07d482c2e4a8767.svg";
export { ForwardRef as ReactComponent };